import template from './template.html';
import {get} from 'lodash';
import {MENU_IDS} from "../../options/constants";

export default {
    name: 'globalFooter',
    template: template,
    methods: {
        initCF7() {
            $(this.$refs.holder).find('.wpcf7-form').each(function (index, elem) {
                wpcf7.init(elem);

                if (wpcf7.cached) {
                    wpcf7.refill(elem);
                }
            });
        }
    },
    computed: {
        nav() {
            return this.$store.getters.getMenuByID(get(MENU_IDS, 'footer', null));
        },
        subscriptionData() {
            return this.$store.getters.getAcfOptionField('subscription');
        },
        footerData() {
            return this.$store.getters.getAcfOptionField('footer');
        }
    },
    mounted() {
        const vm = this;
        document.onreadystatechange = () => {
            if (document.readyState == 'complete') {
                vm.initCF7();
            }
        }
    }
};